import { render, staticRenderFns } from "./prizeRecord.vue?vue&type=template&id=efaeffa6&scoped=true&"
import script from "./prizeRecord.vue?vue&type=script&lang=js&"
export * from "./prizeRecord.vue?vue&type=script&lang=js&"
import style0 from "./prizeRecord.vue?vue&type=style&index=0&id=efaeffa6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaeffa6",
  null
  
)

export default component.exports